import Monedas from '../Monedas';
import styles from './styles.module.css';
import React, { useEffect, useState } from 'react';
const Cotizaciones = (props) => {
    // useEffect(() => {
    //     const fetchData = async () => {
    //         let response;
    //         try {
    //             const res = await fetch('/api/cotizaciones/indices');
    //             if (!res.ok) {
    //                 throw new Error('error en peticion ');
    //             }

    //             response = await res.json();

    //         } catch (err) {
    //             console.error('Hubo un error al intentar completar la peticion', err);
    //             response = {
    //                 result: [{
    //                     security_id: 'SPMERVAL',
    //                     previous_close: dolar_oficial
    //                 }]
    //             }

    //         } finally {
    //             setResult(response);
    //         }
    //     }

    //     fetchData();
    // }, []);

    return <Monedas {...props}/>;
}

export default Cotizaciones;